import React, { useId, useState } from "react";
import { observer } from "mobx-react-lite";
import { SideDrawer, SideDrawerCloseButton } from "@dmc/ui";
import ApiData from "../../../api/ApiData";
import Msg from "../../../api/Msg";
import { formatClientLkUserFio } from "../../../utils/clientLkUsersUtils";
import { BtnOutlineV4 } from "../../UI/button/BtnOutlineV4";
import { BtnPrimaryv4 } from "../../UI/button/BtnPrimaryv4";

export const CompanyClientLkResetPasswordModal = observer(
  ({ companyId, user, onClose }) => {
    const titleId = useId();
    const [submitting, setSubmitting] = useState(false);

    if (!user) {
      return null;
    }

    const close = () => {
      if (!submitting) {
        onClose();
      }
    };

    const onConfirm = async () => {
      setSubmitting(true);
      const result = await ApiData.resetClientLkUserPassword(companyId, user.id);
      setSubmitting(false);

      if (!result) {
        return;
      }

      const password = result.default_reset_password;
      if (password != null && password !== "") {
        Msg.writeMessages(`Пароль: ${password}`);
      } else if (result.message) {
        Msg.writeMessages(result.message);
      }
      onClose();
    };

    const fio = formatClientLkUserFio(user);
    const confirmName = [user.last_name, user.first_name]
      .filter(Boolean)
      .join(" ");

    return (
      <SideDrawer
        title="Сброс пароля"
        titleId={titleId}
        onClose={close}
        usePortal={false}
        toolbar={<SideDrawerCloseButton onClick={close} title="Закрыть" />}
        footer={
          <>
            <BtnPrimaryv4
              footerSize
              text={submitting ? "Сброс…" : "Сбросить пароль"}
              onClick={onConfirm}
            />
            <BtnOutlineV4 text="Отмена" onClick={close} />
          </>
        }
      >
        <div className="site-modal-body">
          <p className="admin-confirm-text">
            Вы точно хотите сбросить пароль для{" "}
            <strong>{confirmName || fio}</strong>?
          </p>
        </div>
      </SideDrawer>
    );
  },
);
